import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Modal from 'modules/core/components/Modal'
// Hooks
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import employees from 'modules/employees/store/collections/employees'
import Form, { DashboardForm } from 'modules/reports/components/DashboardForm'
import dashboards from 'modules/reports/store/collections/dashboards'

interface Props {
  onClose: () => void
  onSuccess: (dashboardId: string) => void
}

const DashboardNewModal = ({ onClose, onSuccess }: Props) => {
  const form = React.useMemo<DashboardForm>(() => new DashboardForm({}), [])

  const { running: isProcessing, performAction: onSubmit } = useAsyncAction(
    async () => {
      const { success, value } = await asyncAction(() => form.create(dashboards), {
        successFlash: true,
        errorFlash: false,
      })

      if (success) {
        onSuccess(value.id)
      }
    },
    {
      successFlash: false,
      errorFlash: false,
    }
  )

  const { employee: currentEmployeeGraphQL } = useCurrentSession()
  const currentEmployee = currentEmployeeGraphQL
    ? employees.find({ id: currentEmployeeGraphQL.id })
    : undefined
  const { value: canManage } = useAsyncCan('reports.manage', currentEmployee || undefined)

  return (
    <AuthorizeUser authorizeFn={() => canManage}>
      <Modal
        illustration="user-interaction-review_chart"
        title={i18n.t('custom_reports.dashboard.modal.create.title')}
        description={i18n.t('custom_reports.dashboard.modal.create.description')}
        onClose={onClose}
        onSubmit={onSubmit}
        footer={
          <>
            <Button type="secondary" onClick={onClose}>
              {i18n.t('common.cancel')}
            </Button>
            <Button disabled={isProcessing || !form.isCompleted} submit>
              {i18n.t('common.create')}
            </Button>
          </>
        }
      >
        <Form form={form} />
      </Modal>
    </AuthorizeUser>
  )
}

export default observer(DashboardNewModal)
